import { CredentialTemplateModal } from './CredentialTemplateModal';
export * from './CredentialTemplateModalTabs';

export default CredentialTemplateModal;
